import { FLAT_RATE_PLANS } from "@common/flatRateBilling";
import { OrganizationServicesOffered } from "@common/types/organization";
import { z } from "zod";

export const editClientSchema = z.object({
    clientName: z.string().min(1, "Client name is required"),
    bookkeepingStartDate: z.string().min(1, "Start date is required"),
    servicesOffered: z
        .array(z.nativeEnum(OrganizationServicesOffered))
        .min(1, "At least one service is required"),
    note: z.string().nullable().optional(),
});

export const isFlatRatePlan = (plan: string | null): plan is FLAT_RATE_PLANS =>
    plan != null &&
    Object.values(FLAT_RATE_PLANS).some((value) => value === plan);

export type EditClientFormSchema = z.infer<typeof editClientSchema> & {
    plan?: string | null;
};
